import { Duration, NextStep } from '@/__generated__/graphql';

export const GRANT_DURATION_DISPLAY_TEXT: Record<Duration, string> = {
  [Duration.Rolling]: 'Rolling',
  [Duration.NotAcceptingProposalsAnymore]: 'Not accepting proposals anymore',
  [Duration.Monthly]: 'Monthly',
  [Duration.NoInformationYet]: 'No information yet',
  [Duration.Quarterly]: 'Quarterly',
  [Duration.Seasonal]: 'Seasonal',
  [Duration.TwiceAYear]: 'Twice a year',
  [Duration.Yearly]: 'Yearly',
};

export const GRANT_NEXT_STEP_DISPLAY_TEXT: Record<NextStep, string> = {
  [NextStep.ApplyOnline]: 'Apply online',
  [NextStep.ByMail]: 'By mail',
  [NextStep.EmailReachOut]: 'Email reach out',
  [NextStep.SendingApplicationsByEmail]: 'Apply by email',
  [NextStep.Loi]: 'LOI',
  [NextStep.InPersonApplication]: 'Apply in person',
  [NextStep.OnlineInquiryForm]: 'Online form',
};
